// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function BellSlashIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M6.74 4.327a1 1 0 1 0-1.48 1.346l2.092 2.302A9.949 9.949 0 0 0 6 13c0 4.418-1.033 7.797-1.726 8.992A2 2 0 0 0 6 25h5.1a5 5 0 0 0 9.8 0h1.93l2.43 2.672a1 1 0 1 0 1.48-1.345l-20-22ZM16 27a3 3 0 0 1-2.828-2h5.655A3 3 0 0 1 16 27ZM6 23c.962-1.655 2-5.49 2-10a7.956 7.956 0 0 1 .782-3.453L21.012 23H6Zm20.75-.591a1 1 0 0 1-1.296-.566C24.544 19.523 24 16.219 24 13a8 8 0 0 0-11.946-6.961 1 1 0 0 1-.988-1.739A10 10 0 0 1 26 13c0 4.419 1.006 7.324 1.315 8.11a1 1 0 0 1-.565 1.296v.003Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
